export function replaceWH(url) {
    // 使用正则表达式匹配 w.h 并替换为指定的宽高
    return convertToHttps(url)?.replace(/w\.h/, `${408}.${544}`);
}
/**
 * 将 HTTP 图片 URL 转换为 HTTPS
 * @param url 输入的 URL
 * @returns 如果是 HTTP 图片 URL 则返回转换后的 HTTPS URL，否则返回原 URL
 */
export function convertToHttps(url) {
    // 检查 URL 是否为空或不是字符串类型
    if (!url || typeof url !== 'string') {
        return url;
    }
    // 检查 URL 是否以 "http://" 开头
    if (url.indexOf('http://') !== 0) {
        return url;
    }
    // 提取域名后的路径
    const path = url.slice(7); // 7 是 "http://".length
    // 检查是否为图片 URL
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
    const isImage = imageExtensions.some(ext => path.toLowerCase().indexOf(ext) > -1);
    if (isImage) {
        return 'https://' + path;
    }
    return url;
}
